import styled from 'styled-components';

export const HubspotMeetingWrapper = styled.div<{
  background: 'white' | 'primary';
}>`
  background-color: ${(props) => props.theme.colors[props.background]};

  h1 {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    font-size: 32px;
    font-weight: 600;
    margin-top: 0px;
    margin-bottom: 20px;
    color: ${(props) => (props.background === 'primary' ? 'white' : props.theme.colors.darkText)};
  }

  p {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-top: 0;
    font-size: 20px;
    margin-bottom: 24px;
  }
`;
